var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#25262F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4791 16.6875C33.3554 16.1931 33.1034 15.7402 32.7485 15.3744C32.3937 15.0086 31.9486 14.7429 31.4583 14.6042C29.6666 14.1667 22.4999 14.1667 22.4999 14.1667C22.4999 14.1667 15.3333 14.1667 13.5416 14.6458C13.0512 14.7846 12.6062 15.0503 12.2513 15.4161C11.8965 15.7819 11.6445 16.2348 11.5208 16.7292C11.1929 18.5475 11.0325 20.392 11.0416 22.2396C11.0299 24.1011 11.1903 25.9597 11.5208 27.7917C11.6572 28.2707 11.9148 28.7064 12.2688 29.0568C12.6228 29.4071 13.0612 29.6602 13.5416 29.7917C15.3333 30.2708 22.4999 30.2708 22.4999 30.2708C22.4999 30.2708 29.6666 30.2708 31.4583 29.7917C31.9486 29.6529 32.3937 29.3873 32.7485 29.0215C33.1034 28.6557 33.3554 28.2027 33.4791 27.7083C33.8045 25.9037 33.9649 24.0733 33.9583 22.2396C33.97 20.3781 33.8096 18.5195 33.4791 16.6875Z",
    stroke: "#E7E7E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1562 25.6458L26.1458 22.2396L20.1562 18.8333V25.6458Z",
    stroke: "#E7E7E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon_youtube.b29df07c3972caf5a018a4a72eef1462.svg";
export { ForwardRef as ReactComponent };